<template>
  <v-select
    id="axis-select"
    v-model="filter.eixo"
    item-text="nome"
    item-name="eixoId"
    :items="axis"
    label="Eixo"
    placeholder="Eixo"
    :return-object=true
  >
    <template slot="no-data">
      Nenhum Eixo retornado
    </template>
  </v-select>
</template>

<script>
import { axisAPI } from '@/modules/axis'

export default {
  name: 'AppAxisByCityCombobox',
  props: [
    'filter'
  ],
  mounted () {
    this.loadAxis()
  },
  methods: {
    loadAxis () {
      axisAPI.getByCity(this.filter.municipioId)
        .then(resp => {
          this.axis = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      axis: []
    }
  }
}
</script>
